// import node module libraries
import { ProgressBar } from "react-bootstrap";
import { useSelector } from "react-redux";

const QuizProgress = (props) => {
  const { quiz, question } = useSelector((state) => state.quizs);
  let progress = (props.currentQuestion / quiz.questions.length) * 100;
  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between">
        <span>Exam Progress:</span>
        <span>
          {" "}
          Question {props.currentQuestion} out of {quiz.questions.length}
        </span>
      </div>
      <div className="mt-2">
        <ProgressBar style={{ height: "6px" }}>
          <ProgressBar
            now={progress}
            style={{ width: progress + "%" }}
            variant="success"
          />
        </ProgressBar>
      </div>
    </div>
  );
};
export default QuizProgress;
